import useAsyncRequest from "../../CustomHooks/useAsyncRequest"
import ContributorBar from "../../Github/Contributos/ContributorBar"
import useGetContributors from "../../Github/Hooks/useGetContributors"
import { supabase } from "../../router"
import { Carousel, HiddenContent, ImgSlide } from "../Carousel"
import { Page } from "../Page"
import { LanguageBar, ProjectSourceCode, ProjectText, ProjectTitle } from "../ProjectPage"
import { ProjectSourceCodeV2 } from "../SourceCode/ProjectSourceCodeV2"

export function CornerDetection() {
    let response = useAsyncRequest( async setResponse => {
        let { data, error } = await supabase
        .rpc('get_project_data', {
            project_name: "Corner Detection"
        })

        if (error) console.error(error)
        else console.log(data)

        setResponse({
            data: data,
            error: error
        });
    });

    const repo = response?.data[0]?.repo;
    const owner = response?.data[0]?.ownername;
    const contributors = useGetContributors({ repo: repo , owner: owner})
    
    let body = null;
    if (response !== null) {
        let projectData = response.data[0];
        let results = projectData.imgs.map((imgData, index ) => {
            return <ImgSlide key = {index} imgData={imgData} status={"pass"} />
        })
        
        let sourceFiles = projectData.files;
        console.log(response);
        
        body = <Page>
            <ProjectTitle title={projectData.name} />
            <LanguageBar languages={projectData.langs}/>
            <ContributorBar contributors={contributors}/>
            <ProjectText text={projectData.abstract[0]} title={"Overview:"}/>
            <Carousel items={results} title={"Results"} elevation={4} interval={3000} />
            <ProjectText text={projectData.paragraphs[0].paragraph} title={"Observations:"}/>
            
            <HiddenContent
                messages={[
                    "View source",
                    "Display source code",
                    "See implementation"
                ]}

                btnText={"Show"}
                interval={3000}
                elevation={4}
            >
                <ProjectSourceCodeV2 elevation={4} directory={projectData?.directory}/>
            </HiddenContent>
        </Page>
    }
    return (<>
        {body}
    </>)
}